<div class="clock-line">
  <span class="date-part">{{ dayName }} {{ dayNum }} {{ monthName }}</span>
  <span class="sep">|</span>
  <span class="time-part">{{ timeStr }}</span>
</div>
